import UserDataService from "../../services/UserDataService"

// objectives =­> objectiveProgressions
var userDataStore = {
    state: () => ({
        objectives: []
    }),

    mutations: {
        SET_OBJECTIVES(state, { objectives }) {
            state.objectives = objectives
        }
    },

    actions: {
        setObjectives(context, { objectives }) {
            context.commit('SET_OBJECTIVES', { objectives })
        },

        loadDefaultUserDataPackage(context) {
            UserDataService.getDefaultUserDataPackage().then((response) => {
                context.commit('SET_OBJECTIVES', { objectives: response.objectiveProgressions })
            })
        }
    },

    getters: {
        getObjectives(state) {
            return state.objectives
        }
    }

}

export default userDataStore